import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-valide-cmd',
  templateUrl: './valide-cmd.component.html',
  styleUrls: ['./valide-cmd.component.scss']
})
export class ValideCmdComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        console.log('ValideCmdComponent initialized');
        // Appliquer le filtrage initial pour le statut "Valide"
        this.dataService.filterOrdersByStatus('Valide');
    }

}
